import React from "react";

import PageComponent from "components/Page";

import './index.less';
import './themes/default.less';
import Button from "components/Button";

import Search from "components/Search";
import MultiSelect from "components/MultiSelect";
import Table from "components/Table";

import CreatePopup from "./components/createEmployeePopup";

import AvatarUploadDialog from "../../components/AvatarUploadDialog";
import ToggleSwitch from "components/ToggleSwitch";


import EmployeesFilter from "./components/employeesFilter";
import FilterItem from "./components/filterItem";


export default class Employees extends PageComponent {

    constructor(props) {
        super(props);

        this.tableMap = {

            photoUid: {
                label: "employee.foto",
                type: "avatar",
                size: "40px",
                hideLabel: true,
                sortKey: ""
            },
            fio: {
                label: "employee.fio",
                type: "rows",
                rows: ["lname", "fname, sname"],
                sortKey: "lname",
            },
            roleId: {
                label: "employee.role_system",
                type: "role",

            },
            specs: {
                label: "employee.specialization",
                type: "spec",
                size: "400px",
            },
            status: {
                label: "employee.status",
                type: "emp_status",
            },

            phoneNumber: {
                label: "employee.tel",
                type: "phone",
            },

            experienceBeginning: {
                label: "employee.experience",
                type: "emp_experience",
            },

            /*actions: {
                label: "employee.go_profile",
                type: "icon",
                size: "50px",
                hideLabel: true,
                name: "arrow",
                click: this.goProfile.bind(this)
            },*/
        };

        this.tableRowProps = {
            useIds: true,
            format: this.rowFormat.bind(this),
            click: this.goProfile.bind(this)
        };

        const keys = Object.keys(this.tableMap);

        this.state = {
            ...this.state,
            items: [],
            //emStart: false,
            selected: keys,
            sort: "lname",
            value: "",
            viewFired: false,
            filters: [
                { id: "roleId", value: 4, labelValue: this._helper.getRoleLabel(4), labelType: this.tr("employee.role_system") },
                { id: "status", value: "WORK", labelValue: this._helper.getEmploeeStatusLabel("WORK"), labelType: this.tr("employee.status") }
            ]
        };

        this.selectItems = keys.map(key => {
            return { id: key, name: this.tr(this.tableMap[key].label) };
        });

    }

    get rightPopupsMap() {
        return {
            "createEmployee": CreatePopup,

        };
    }

    get dialogsMap() {
        return {
            "avatarUpload": AvatarUploadDialog,
        };
    }

    goProfile(info) {
        this._helper.openEmployee(info.id);
    }

    rowFormat({ status }, cl) {

        if (status === "FIRED")
            cl.push("disabled");

        return cl;
    }

    componentDidLoad() {
        this.getData();
    }

    async getData(clrCache = false) {
        this._helper.showLoading();

        const { data } = await this._request.employees.getAll();

        if (data) {
            this.setState({
                items: data,
            });
        }

        this._helper.hideLoading();

        if (clrCache) {
            this._request.doctors.clearSelfCache();
        }
    }

    onSortChange(sort) {

        if (sort !== "") {
            this.setState({ sort });
        }

    }

    onSearchChange(value) {
        clearTimeout(this.clientsTimer);
        this.clientsTimer = setTimeout(() => {
            clearTimeout(this.clientsTimer);
            this.setState({ value });
            //this.state.value = value;
            // this.getData();
        }, 1000);
    }

    getFiledsLabel(l) {
        let filedsTr = "columns";
        if (l === 1)
            filedsTr = "column";
        else if (l < 5)
            filedsTr = "columna";

        return l + " " + this.tr("main", filedsTr).toLowerCase();
    }

    onAdd() {
        this.openRightPopup("createEmployee", this.state.clinicId, this.onAddEmployee.bind(this));
    }

    async onAddEmployee(empData) {
        const resp = await this._request.employees.addEmployee(empData.profile);

        if (resp.code === "success") {
            if (empData.photo !== null) {
                this._request.images.uploadEmployeeAvatar(resp.data.id, empData.photo, (error, result) => {
                    if (!error) {
                        const { code, data } = JSON.parse(result);
                        if (code === "success") {
                            if (Array.isArray(data) && data.length > 0) {
                                this.getData(true);
                            }
                        }
                    } else {
                        this.getData(true);
                    }
                });
            }

            this.getData(true);

        } else {
            this.showError(resp.message);
        }

    }

    hasFired(arr) {
        if (arr.length > 0) {
            let index = arr.findIndex(it => it.id === "status" && it.value === "FIRED");
            if (index >= 0)
                return true;
        }

        return false;
    }
    useFilterViewFired() {

        const { viewFired } = this.state;
        this.setState({ viewFired: !viewFired });
    }

    insertToggleSwitch(props) {
        return <ToggleSwitch {...props} />;
    }

    onChangeFilter(filt) {
        this.setState({ filters: filt });
    }

    onCloseFilterItem(item) {
        this.employeesFilter.onRemoveFilter(item);
    }

    hasSpec(specId, arr) {

        if (arr && arr.length > 0) {

            let it = arr.find(_it => _it.specEntity.id === specId);

            if (it !== undefined) {
                return true;
            }
        }

        return false;
    }

    calcOR(arr) {

        let res;

        if (arr.length === 1) {
            res = arr[0];
        } else if (arr.length === 2) {
            res = arr[0] || arr[1];

        } else {
            res = arr[0];

            for (let i = 1; i < arr.length; i++) {
                res = res || arr[i];
            }

        }

        return res;
    }

    calcAND(arr) {

        if (arr.length === 0) {
            return true;
        }

        let res;

        if (arr.length === 1) {
            res = arr[0];
        } else if (arr.length === 2) {
            res = arr[0] && arr[1];
        } else {
            res = arr[0];

            for (let i = 1; i < arr.length; i++) {
                res = res && arr[i];
            }
        }

        return res;
    }

    applyFired(profile) {
        const { viewFired } = this.state;

        if (viewFired) {
            return true;
        }

        return (profile.status !== "FIRED");
    }

    applyFilters(profile, filters) {

        let arole = [];
        let aspec = [];
        let astatus = [];

        for (let fIt of filters) {

            switch (fIt.id) {

                case "roleId":
                    arole.push(profile.roleId === fIt.value);
                    break;

                case "specId":
                    aspec.push(this.hasSpec(fIt.value, profile.specs));
                    break;

                case "status":
                    astatus.push(profile.status === fIt.value);
                    break;

                default:
                    break;
            }

        }

        let res = [];

        if (arole.length > 0) {
            res.push(this.calcOR(arole));
        }

        if (aspec.length > 0) {
            res.push(this.calcOR(aspec));
        }

        if (astatus.length > 0) {
            res.push(this.calcOR(astatus));
        }

        return this.calcAND(res) && this.applyFired(profile);
    }

    renderPage() {
        const { items, selected, sort, value, viewFired, filters } = this.state;
        const filedsLabel = this.getFiledsLabel(selected.length);

        const map = {};
        Object.keys(this.tableMap).forEach(key => {
            if (selected.includes(key))
                map[key] = this.tableMap[key];
        });

        let vItems = [];

        if (value !== "") {
            vItems = items.filter(it => {
                if (!this.state.viewFired) {
                    return ((it.lname.toLowerCase().indexOf(value.toLowerCase()) === 0 || it.fname.toLowerCase().indexOf(value.toLowerCase()) === 0) && it.status !== "FIRED");
                }
                return (it.lname.toLowerCase().indexOf(value.toLowerCase()) === 0 || it.fname.toLowerCase().indexOf(value.toLowerCase()) === 0);
            });
        } else if (filters.length > 0) {
            vItems = items.filter(it => this.applyFilters(it, filters));
        } else {
            vItems = items.filter(it => this.applyFired(it));
        }

        let xsort = sort === "" ? "lname" : sort;
        let sObj = this._helper.getSortField(xsort);

        vItems.sort((a, b) => {
            if (sObj.direction === "ASC") {
                return a[sObj.field] > b[sObj.field] ? 1 : -1;
            }
            return a[sObj.field] > b[sObj.field] ? -1 : 1;
        });

        return (
            <div className="flex1 flex col gap16">
                <div className="header flex between centerV">
                    <div className="left flex text pageTitle">{this.tr("menu.employees")}</div>
                    <div className="flex gap16">
                        <div className="flex">
                            <Search
                                itemStyle="search"
                                placeHolder="employee.search_label"
                                onChange={this.onSearchChange.bind(this)}
                            />
                        </div>
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"employee.add_employee"}
                            active={false}
                            onClick={this.onAdd.bind(this)}
                        />
                    </div>
                </div>
                <div className="flex between">
                    <div className="flex">
                        <EmployeesFilter ref={el => this.employeesFilter = el} onChangeFilter={this.onChangeFilter.bind(this)} />
                    </div>
                    <div className="flex centerV gap16">
                        <div className="text textDiv">{this._helper.trInsValues("employee.viewCount", vItems.length)}</div>
                        {this.insertToggleSwitch({
                            checked: viewFired,
                            label: "employee.viewFired",
                            onChange: this.useFilterViewFired.bind(this)
                        })}
                        <MultiSelect
                            min={1}
                            selected={selected}
                            items={this.selectItems}
                            fixedHolder={filedsLabel}
                            onChange={this.changeState.bind(this, "selected")}
                        />
                    </div>
                </div>
                <div className="flex wrap">
                    {filters.length > 0 ? filters.map((it, ind) => <FilterItem {...it} key={ind} onClose={this.onCloseFilterItem.bind(this)} />) : null}
                </div>
                <Table
                    map={map}
                    items={vItems}
                    sort={sort}
                    onSortChange={this.onSortChange.bind(this)}
                    rowProps={this.tableRowProps}
                />
                <div></div>
            </div>
        );
    }

}
